import { render, staticRenderFns } from "./PublishArticleButton.vue?vue&type=template&id=e5dc163a&"
import script from "./PublishArticleButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PublishArticleButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports